
export interface upLoadFile {
  id: string;
  name: string;
  size: number;
  url: string;
}
class UploadService {
  private callbacks: ((file: {value:upLoadFile,model:string}) => void)[] = [];

  public registerCallback(callback: (file: {value:upLoadFile,model:string}) => void) {
    this.callbacks.push(callback);
  }

  public notifyFileUploaded(file:{value:upLoadFile,model:string}) {
    this.callbacks.forEach(callback => callback(file));
  }
}

export const uploadService = new UploadService();